import React from 'react'

import {
  FieldSpec,
  NumberField,
  PaginatedTable,
  ReceiveStatusField,
  RelatedLinkedField,
  UnitLocUnitField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  asn: {
    id: 'asn',
    label: 'ASN',
    ordering: 'asn__tracking_number',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  sku: {
    id: 'sku',
    label: 'SKU',
    ordering: 'sku__sku',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  productName: {
    id: 'productName',
    label: 'Product Name',
    ordering: 'sku__product_name',
    renderer: ValueField,
  },
  product: {
    id: 'product',
    label: 'Product',
    ordering: 'product__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  numUnits: {
    id: 'numUnits',
    label: 'Number of Units Ordered',
    ordering: 'num_units',
    renderer: UnitLocUnitField,
  },
  receivedStatus: {
    id: 'numReceived',
    label: 'Received Status',
    ordering: 'num_received',
    renderer: ReceiveStatusField,
  },
  shortage: { id: 'shortage', label: 'Short', ordering: 'shortage', renderer: NumberField },
}

export const ASNExpectedUnitListTable = (props: ListTableProps) => {
  const { paginator, fields, title = 'ASN Units Expected to be Received', exportConfig } = props

  return (
    <>
      <PaginatedTable
        title={title}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
